const childVisibleForStatus = (child, status) => {
  if (status === "all") return true
  if (status === "inactive") return child.deletedAt !== null
  return child.deletedAt === null
}

const flattenProducts = (products = [], status = "active") =>
  products.flatMap((product) => {
    const parent = { ...product, isInventoryChild: false }
    const children = (product.inventoryChildProducts || [])
      .filter((child) => childVisibleForStatus(child, status))
      .map((child) => ({
        ...child,
        isInventoryChild: true,
        parentId: product.id,
      }))

    return [parent, ...children]
  })

export default flattenProducts
